export default __webpack_public_path__ + "static/media/wallet-blue.d51315a0.svg";